module.exports = __webpack_public_path__ + "src/img/guanli.4bb4f5ff.svg";